import React from 'react';
import { Save } from 'react-feather';
import { useToggle } from 'hooks';
import TemplateCreationModal from '../TemplateCreationModal';

const SaveLessonAsTemplate = () => {
  const [modalVisible, toggleModalVisible] = useToggle();

  return (
    <>
      <div
        onClick={toggleModalVisible}
        onKeyDown={e => e.key === 'Enter' && toggleModalVisible()}
        tabIndex="0"
        role="button"
        className="SaveLessonAsTemplate--button PanelToolbar-link"
      >
        <Save className="Icon" />
        {t('actions.save_as_template')}
      </div>
      {modalVisible && (
        <TemplateCreationModal
          closeModal={() => toggleModalVisible(false)}
          fromLesson
        />
      )}
    </>
  );
};

export default SaveLessonAsTemplate;
